/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Ourwork1Inputs */

const ja_nav_ourwork1 = /** @type {(inputs: Nav_Ourwork1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制作実績`)
};

const en_nav_ourwork1 = /** @type {(inputs: Nav_Ourwork1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OUR WORK`)
};

/**
* | output |
* | --- |
* | "OUR WORK" |
*
* @param {Nav_Ourwork1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const nav_ourwork1 = /** @type {((inputs?: Nav_Ourwork1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Ourwork1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_ourwork1(inputs)
	return en_nav_ourwork1(inputs)
});
export { nav_ourwork1 as "nav_ourWork" }